import { Button, Dialog } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";
import { useIntl } from "react-intl";

interface RetrySuccessModal {
  open: boolean;
  fileName: string;
  onClose: () => void;
}

const RetrySuccessModal = ({ open, fileName, onClose }: RetrySuccessModal) => {
  const intl = useIntl();
  return (
    <Dialog style={{ borderRadius: 16 }} open={open} onClose={onClose}>
      <div style={{ padding: "32px 24px", maxWidth: 400 }}>
        <MyTypography variant="subtitle1">
          {intl.formatMessage({ defaultMessage: "การอัพโหลดไฟล์สำเร็จ" })}
        </MyTypography>
        <MyTypography variant="body2" style={{ padding: "24px 0 32px 0" }}>
          {fileName} อัพโหลดเสร็จสมบูรณ์ กรุณารอยืนยันใบสั่งซื้อทาง e-mail
        </MyTypography>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={onClose}
            variant="contained"
            color={"secondary"}
            style={{ width: 178, justifyItems: "center" }}
          >
            {intl.formatMessage({ defaultMessage: " ปิด" })}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default RetrySuccessModal;
